module.exports = __webpack_public_path__ + "static/media/linha_colorida.db599c82.svg";